module.exports = __webpack_public_path__ + "img/92131.0afdc67f.svg";